// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerCard_root__2SrzC","answer":"AnswerCard_answer__3_pm8","question":"AnswerCard_question__3LBaJ"};